<div class="max-w-6xl mx-auto p-4 flex items-center">
    <ul class="flex space-x-4" *ngIf="collectionTree$ | async as tree">
        <li
            class="nav-item"
            *ngFor="let collection of tree.children"
            (mouseenter)="onMouseEnter(collection)"
            (mouseleave)="close($event)"
        >
            <a
                class="nav-link hover:text-primary-600"
                [class.active]="
                    (setActiveCollection$ | async)?.id === collection.id &&
                        overlayIsOpen$ | async
                "
                (touchstart)="onTopLevelClick($event, collection)"
                [routerLink]="['/category', collection.slug]"
                >{{ collection.name }}</a
            >
        </li>
        <li class="nav-item">
            <a
                class="nav-link hover:text-primary-600"
                routerLink="/pricelists/pre-order"
                routerLinkActive="active"
            >Pre-Orders</a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link hover:text-primary-600"
                routerLink="/consolidated-feed"
                routerLinkActive="active"
            >Consolidated Feed</a>
        </li>
    </ul>
</div>

<ng-template #menuTemplate>
    <div
        class="collections-menu-sub-collections"
        *ngIf="activeCollection?.children?.length"
        (touchstart)="captureTouchStart($event)"
        (mouseenter)="onMouseEnter(activeCollection)"
        (mouseleave)="close()"
    >
        <div class="container d-flex flex-wrap">
            <div
                class="level-1-block"
                *ngFor="let level1 of activeCollection.children"
            >
                <vsf-collection-card
                    [collection]="level1"
                ></vsf-collection-card>
                <ng-container *ngFor="let level2 of level1.children">
                    <a
                        class="level-2-link"
                        [routerLink]="['/category', level2.slug]"
                        (click)="close()"
                    >
                        {{ level2.name }}
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>
